import archimedes from "./archimedes";
import xenophon from "./xenophon";
import thales from "./thales";

const generators = { archimedes, xenophon, thales };

export default generators;
